<template>
  <div>
    <form role='form'>
      <div class='modal-body'>
        <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' v-if='successShow'>
          'تم تعديل الايصال بنجاح'
        </div>
        <fieldset>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>الفرع:</label>
            <select style="padding: 0px" @change="emptyRecord()" class="form-control"  v-model="branch_id" >
              <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>النوع:</label>
            <select style="padding: 0px" @change="emptyRecord();changeType()" class="form-control"  v-model="IDtype" >
              <option v-for="item in IDtypes" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>{{typeStr}}:</label>
            <input v-model='receiptID' v-on:keypress="GetDataKey($event)" class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-3 col-sm-3' style="padding-top: 23px">
            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            <button @click="GetData()" type='button' class='btn btn-primary btn-md btn-block'>عرض</button>
          </div>
          <div class='col-lg-9 col-sm-9' style='padding: 0px 0px 10px 0px'>
            <label>الاسم:</label>
            <input disabled v-model='customer_name' class='form-control' name='branchname' type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 0px 0px 10px 0px'>
            <label>الكود:</label>
            <input disabled v-model='rec_id'  class='form-control' name='branchname' type='text'>
          </div>
          <table width='100%' class='table table-striped table-bordered table-hover' >
            <thead>
              <tr>
                <th style='padding:2px;text-align: center'>الايصال</th>
                <th style='padding:2px;text-align: center'>الحافظة</th>
                <th style='padding:2px;text-align: center'>الفنى</th>
                <th style='padding:2px;text-align: center'>الحالة</th>
                <th style='padding:2px;text-align: center'></th>
              </tr>
            </thead>
            <tbody>
              <tr class='odd gradeX' v-for='(record) in record' :key='record.id'>
                <td style='padding:2px;text-align: center'>{{record.cash_receipt_id}}</td>
                <td style='padding:2px;text-align: center'>{{record.folder_date}}</td>
                <td style='padding:2px;text-align: center'>{{record.user_tec}}</td>
                <td style='padding:2px;text-align: center'>{{record.type}}</td>
                <td style='padding:2px;text-align: center'>
                  <button @click='printReceipt(record)' type="button" class="btn btn-default btn-xs">طباعة</button>
                  <button @click='alterReceipt(record)' type="button" class="btn btn-primary btn-xs">تعديل</button>
                  <button @click='removerec(record.cash_receipt_id)' :class="record.treasury_id ? '' : 'disabled'" type="button" class="btn btn-warning disabled btn-xs">حذف</button>
                </td>
              </tr>
            </tbody>
          </table>
        </fieldset>
        <div class="row" v-show='isAlter'>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 10px 5px 10px;'>
            <span>غرض الاتصال:</span>
            <input disabled value='سداد قسط فلتر' class='form-control' name='notes' type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>حالة الاتصال:</span>
            <select class="form-control" style="padding: 0px" v-model="recAlter.call_status_id">
              <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 5px 10px;'>
            <span>الاجراء:</span>
            <select class="form-control" style="padding: 0px" v-model="recAlter.action_id">
              <option v-for="item in actions" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>تاريخ الحافظة:</label>
            <input disabled v-model='recAlter.folder_date' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-6 col-sm-6'>
            <label>ملاحظات الاتصال:</label>
            <input v-model='recAlter.call_logs_notes'  @keyup='mirrorNotes()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-6 col-sm-6'>
            <label>ملاحظات الفنى :</label>
            <input v-model='recAlter.notes' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>مدة التأجيل:</label>
            <input v-model='recAlter.delay' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>تاريخ القسط:</label>
            <input v-model='recAlter.date' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>المدفوع:</label>
            <input v-model='recAlter.amount' @keyup='SetAmount()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-2 col-sm-2'>
            <label>الباقى:</label>
            <input v-model='recAlter.rest' @keyup='SetRest()' class='form-control' name='branchname' type='text'>
          </div>
          <div class='form-group col-lg-3 col-sm-3'>
            <label>م الصيانة:</label>
            <input disabled v-model='recAlter.maintenance_expenses' class='form-control' name='branchname' type='text'>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 15px 0px 10px;'>
            <label>المدفوع:</label>
            {{recAlter.amount_str}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 15px 0px 10px;'>
            <label>البيان:</label>
            {{recAlter.caption}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 15px 0px 10px;'>
            <label>الباقى:</label>
            {{recAlter.rest_str}}
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 15px 0px 10px;text-align: center;'>
            <button @click='saveData()' type='button' class='btn btn-primary'>حفظ</button>
          </div>
        </div>
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
      </div>
    </form>
    <PrintReceipts ref="PrintReceipts"> </PrintReceipts>
  </div>
</template>
<script>
import axios from 'axios'
import PrintReceipts from '@/components/Sales/PrintReceipts'
import tafqeet from '@/./assets/Tafqeet.js'
export default {
  name: 'SearchReceipt',
  components: {
    PrintReceipts
  },
  data () {
    return {
      callStatus: [],
      isAlter: false,
      recAlter: '',
      customer_name: '',
      rec_id: '',
      IDtypes: [
        {id: 0, name: 'كود العميل'},
        {id: 1, name: 'رقم الايصال'}
      ],
      typeStr: 'رقم الايصال',
      IDtype: 1,
      branches: {},
      branch_id: 0,
      receiptID: null,
      record: [],
      isLoadingData: false,
      validationErrors: null,
      successShow: null,
      actions: [],
      types: [
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'تغيير شمع وسداد'},
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      folder_date: '',
      records: {},
      errorShow: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      modelCollectors: {},
      collectors: {},
      CollectorRecords: [],
      collector_id: 0,
      modelCollectorId: '',
      cashReceipts: '',
      id: ''
    }
  },
  methods: {
    pageLoad () {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    },
    // ======================================================
    GetDataKey (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      this.emptyRecord()
      if (charCode === 13) {
        this.GetData()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45 && charCode !== 42) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ======================================
    changeType () {
      if (this.IDtype === 0) {
        this.typeStr = 'كود العميل'
      } else {
        this.typeStr = 'رقم الايصال'
      }
    },
    // ======================================
    emptyRecord () {
      this.record = []
    },
    // ======================================
    GetData () {
      this.customer_name = ''
      this.rec_id = ''
      this.record = []
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'search-receipt-data', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        id: this.receiptID,
        type: this.IDtype
      })
        .then(({ data }) => {
          if (data.length > 0) {
            this.customer_name = data[0].customer_name
            this.rec_id = data[0].rec_id
            this.record = data
          }
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    alterReceipt (rec) {
      this.isAlter = false
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'get-receipt-data', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        id: rec.id
      })
        .then(({ data }) => {
          this.isAlter = true
          this.recAlter = data.Data
          this.actions = data.Actions
          this.callStatus = data.Status
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ======================================
    SetAmount () {
      if (this.recAlter.amount > 0) {
        this.recAlter.amount_str = '-مبلغ وقدره ' + this.recAlter.amount + ' جنيه ' + tafqeet(this.recAlter.amount) + ' جنيهاً فقط لا غير-'
      } else {
        this.recAlter.amount_str = 'لا شيئ'
      }
    },
    // ======================================
    SetRest () {
      if (this.recAlter.rest > 0) {
        this.recAlter.rest_str = 'والمبلغ المتبقى ' + this.recAlter.rest + 'ج فقط ' + tafqeet(this.recAlter.rest) + ' جنيهاً لا غير'
      } else {
        this.recAlter.rest_str = 'المبلغ المتبقى: صفر (لا توجد اى مبالغ متبقية)'
      }
    },
    // ========================================================
    mirrorNotes () {
      this.recAlter.notes = this.recAlter.call_logs_notes
    },
    // ===========================================================
    async printReceipt (rec) {
      var xRate = 0
      var yRate = 0
      var paperSize = 0
      await axios.post(this.$apiURL + 'get-printer-rate', {
        token: localStorage.getItem('token'),
        id: this.branch_id
      })
        .then(({ data }) => {
          xRate = data.x_rate
          yRate = data.y_rate
          paperSize = data.paper_size
        })
      var Receipts = []
      Receipts.push(rec)
      if (paperSize === 0) {
        this.$refs.PrintReceipts.createPDF(Receipts, xRate, yRate)
      } else {
        this.$refs.PrintReceipts.CreatePDF_A5(Receipts, xRate, yRate)
      }
    },
    // ===========================================================
    saveData () {
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'save-receipt-data', {
        token: localStorage.getItem('token'),
        id: this.recAlter.id,
        branch_id: this.branch_id,
        amount: this.recAlter.amount,
        amount_str: this.recAlter.amount_str,
        caption: this.recAlter.caption,
        delay: this.recAlter.delay,
        date: this.recAlter.date,
        maintenance_expenses: this.recAlter.maintenance_expenses,
        rest: this.recAlter.rest,
        rest_str: this.recAlter.rest_str,
        call_logs_notes: this.recAlter.call_logs_notes,
        notes: this.recAlter.notes,
        call_status_id: this.recAlter.call_status_id,
        action_id: this.recAlter.action_id
      })
        .then(res => {
          this.isLoadingData = false
          this.successShow = true
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ===========================================================
    removerec (id) {
      /*
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'delete-receipt-data', {
        token: localStorage.getItem('token'),
        id: id,
        branch_id: this.branch_id
      })
        .then(res => {
          this.emptyRecord()
          this.isLoadingData = false
          this.successShow = true
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
        */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/SearchAlterReceipt.vue